import apiHandler from "../core/apiHandler";

/**
 * 📦 API para el CRUD de grupos de productos guardados
 * Endpoint: /api/product-report-groups
 */
const productReportGroupApi = apiHandler("product-report-groups");

export default productReportGroupApi;
